export enum ResourceImage {
  Undefined = 0,
  DocumentNew = 1,
  DocumentConflict = 2,
  DocumentUpdated = 3,
  DocumentDeleted = 4,
  DocumentDeletedConflict = 5,
  DocumentDeletedUpdated = 6,
  DocumentChanged = 7,
}
